import type { ReactNode } from 'react'
import { Badge } from '../Badge'
import { Icon } from '../Icon'
import { fireHaptic } from '../settings/SettingsActions'

export interface CtaCardProps {
  icon: ReactNode
  title: string
  sub: ReactNode
  disabled?: boolean
  badge?: string
  onClick?: () => void
}

export function CtaCard({
  icon,
  title,
  sub,
  disabled = false,
  badge,
  onClick,
}: CtaCardProps) {
  function handlePointerDown(): void {
    if (disabled) fireHaptic('error')
  }

  return (
    <div
      className={`ctacard${disabled ? ' ctacard--disabled' : ''}`}
      onClick={disabled ? undefined : onClick}
      role="button"
      tabIndex={disabled ? -1 : 0}
      aria-disabled={disabled}
      onPointerDown={disabled ? handlePointerDown : undefined}
      onKeyDown={(e) => {
        if (!disabled && (e.key === 'Enter' || e.key === ' ')) onClick?.()
      }}
    >
      <div className="ctacard__icon">{icon}</div>
      <div className="ctacard__text">
        <div className="ctacard__title">{title}</div>
        <div className="ctacard__sub">{sub}</div>
      </div>
      {badge != null && (
        <div className="ctacard__pill">
          <Badge variant="soon">{badge}</Badge>
        </div>
      )}
      <div className="ctacard__chev">
        <Icon name="chev" size={20} />
      </div>
    </div>
  )
}
